import { Component, Input } from '@angular/core';
import { Chargepoint, ChargepointStatus, ChargepointType, IvyChargepoint, NetatmoChargepoint, OCPPChargepoint, OkechargeChargepoint } from '../../../api/chargepoints-api.service';
import { Observable, switchMap, filter, map, tap, catchError, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { Transaction, TransactionApiService } from '../../../api/transactions-api.service';
import { TransactionStatusComponent } from '../transaction-status/transaction-status.component';
import { JsonViewerService } from '../../common/json-viewer-dialog/json-viewer.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RefreshService } from '../../common/refresh-widget/refresh.service';
import { CopiableInfoComponent } from '../../../elements/copiable-info/copiable-info.component';
import { TransactionMonitorDialogService } from '../transaction-monitor-dialog/transaction-monitor-dialog.service';

@Component({
  selector: 'app-transactions-list',
  templateUrl: './transactions-list.component.html',
  styleUrls: ['./transactions-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatCardModule,
    MatDividerModule,
    MatTableModule,
    TransactionStatusComponent,
    MatTooltipModule,
    CopiableInfoComponent,
  ]
})
export class TransactionsListComponent {

  @Input() chargepoint!: Chargepoint;

  public transactions$: Observable<Transaction[]>;
  public loading = false;
  public fetchingError = false;

  get searchChargepointId(): string {
    if (this.chargepoint.type === ChargepointType.OCPP) {
      return this.chargepoint.id;
    }
    if (this.chargepoint.type === ChargepointType.OKECHARGE) {
      return this.chargepoint.id;
    }
    if (this.chargepoint.type === ChargepointType.IVY) {
      return (this.chargepoint as IvyChargepoint).plugId;
    }
    if (this.chargepoint.type === ChargepointType.NETATMO) {
      return this.chargepoint.id;
    }
    return '';
  }

  get searchChargepointType(): ChargepointType {
    return this.chargepoint.type;
  }

  constructor(
    private transactionApiService: TransactionApiService,
    private transactionMonitorDialogService: TransactionMonitorDialogService,
    public jsonViewerService: JsonViewerService,
    private snackBar: MatSnackBar,
    private refreshService: RefreshService
  ) {
    this.transactions$ = this.refreshService.refreshTrigger.pipe(
      filter(() => !!this.chargepoint),
      tap(() => {
        this.loading = true;
        this.fetchingError = false;
      }),
      switchMap(() => this.transactionApiService.searchTransactions({
        chargepointId: this.searchChargepointId,
        type: this.searchChargepointType
      })),
      tap(() => {
        this.loading = false;
        this.fetchingError = false;
      }),
      catchError(() => {
        this.loading = false;
        this.fetchingError = true;
        return of(null);
      }),
      filter(configuration => configuration !== null),
      map(transactions => transactions.sort((a, b) => b.creationTime.getTime() - a.creationTime.getTime()))
    );
  }

  public openTransactionMonitor(transaction: Transaction): void {
    this.transactionMonitorDialogService.open(transaction);
  }

  public stopTransaction(transactionId: string) {
    this.transactionApiService.stopTransaction(transactionId).subscribe((_transaction) => {
      this.snackBar.open('Transaction stopped', 'Close', { duration: 3000 });
      this.refreshService.trigger();
    });
  }
}
